





























import VueOptions from '@utils/VueOptions'
import MediaSelector from '@ui/MediaSelector'

settings =
  name: 'MediaCarousel'

  vue:
    props: ['value', 'mediaKits', 'tags']

    components: {
      MediaSelector,
    }

    data: ->
      images: @value
      mediaModal:
        show: false

    computed:
      actionsForMediaSelector: ->
        onUpload: @onUploadMedia
        onDone: @selectMedia

    methods:
      hiOpenMediaSelector: ->
        @mediaModal.show = true

      hiRemoveImage: (url) ->
        keys = @images.filter((image) -> image isnt url)
        @selectMedia keys

      onUploadMedia: ->
        @$emit 'onUpload'

      selectMedia: (selectedKeys) ->
        @images = selectedKeys
        @$emit 'input', [...selectedKeys]

export default VueOptions.vue settings
